import "./index.css";
import React from "react";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import BasicLayout from "../../layouts/authentication/components/BasicLayout";
import login from "assets/login.png";

import { useNavigate, useSearchParams } from "react-router-dom";
import { GetReset, ResetPassword } from "api/UserAPI";
import { useAuthState } from "../../context/Auth";

function ResetPass() {
  // Realm sends reset URL as: /authentication/reset-password?token=X&tokenId=Y
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const tokenId = searchParams.get("tokenId");

  const [info, setInfo] = React.useState({});
  const [errors, setErrors] = React.useState({});
  const [variables, setVariables] = React.useState({ email: "" });
  const [variablesReset, setVariablesReset] = React.useState({ password: "" });

  const { getReset, resetLoading } = GetReset(setInfo);
  const { resetPassword, rpLoading } = ResetPassword(setErrors);

  const handleReset = (e) => {
    e.preventDefault();
    getReset({ variables });
  };

  const handlePasswordReset = (e) => {
    e.preventDefault();
    resetPassword({ variables: { token, tokenId, password: variablesReset.password } });
  };

  let forms;
  if (Object.keys(info).length > 0) {
    try {
      forms = JSON.parse(info).accepted !== null;
    } catch (e) {
      forms = false;
    }
  } else {
    forms = false;
  }

  const { user } = useAuthState();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user) navigate("/dashboard", { replace: true });
  }, []);

  return (
    <BasicLayout image={login}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          {token ? (
            <>
              <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
                Reset Password
              </MDTypography>
              <MDTypography display="block" variant="button" color="white" my={1}>
                Enter the details below to update your password
              </MDTypography>
            </>
          ) : (
            <>
              <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
                Reset Password
              </MDTypography>
              <MDTypography display="block" variant="button" color="white" my={1}>
                You will receive an e-mail in maximum 60 seconds
              </MDTypography>
            </>
          )}
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          {Object.keys(info).length > 0 && (
            <MDBox textAlign="center" pt={0} pb={1} px={3}>
              <MDTypography display="block" variant="button" color="black" my={1}>
                {info?.email}
                {forms && `Successfully emailed to: ${JSON.parse(info)?.accepted}`}
              </MDTypography>
            </MDBox>
          )}
          {errors.token && (
            <MDBox textAlign="center" pb={1}>
              <MDTypography variant="button" color="error">{errors.token}</MDTypography>
            </MDBox>
          )}
          {!forms && !token && (
            <MDBox onSubmit={handleReset} component="form" role="form">
              <MDBox mb={4}>
                <MDInput
                  onChange={(e) => setVariables({ ...variables, email: e.target.value })}
                  type="email"
                  label="Email"
                  variant="standard"
                  fullWidth
                />
              </MDBox>
              <MDBox mt={6} mb={1}>
                <MDButton type="input" variant="gradient" color="info" fullWidth>
                  {resetLoading ? <CircularProgress color="warning" /> : "reset"}
                </MDButton>
              </MDBox>
            </MDBox>
          )}
          {token && (
            <MDBox onSubmit={handlePasswordReset} component="form" role="form">
              <MDBox mb={4}>
                <MDInput
                  onChange={(e) => setVariablesReset({ ...variablesReset, password: e.target.value })}
                  type="password"
                  label="New Password"
                  variant="standard"
                  fullWidth
                />
              </MDBox>
              <MDBox mt={6} mb={1}>
                <MDButton type="input" variant="gradient" color="info" fullWidth>
                  {rpLoading ? <CircularProgress color="warning" /> : "reset"}
                </MDButton>
              </MDBox>
            </MDBox>
          )}
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default ResetPass;
